export const styles = {
  levelLabel: {
    color: 'common.black',
  },
  switchInput: {
    ml: 4,
    mr: 1,
  },
};
